import { useCallback, useMemo } from 'react';

import type { APP_PAGES_CONFIG } from 'constants/routes';

import { useSpaNavigation, useAppDispatch } from 'shared/lib';

import { setAppPageName } from 'entities/siteSettings';

export const useClientRedirect = () => {
  const { push: spaPush, prefetch } = useSpaNavigation();
  const dispatch = useAppDispatch();

  const push = useCallback(
    async (pageName: keyof typeof APP_PAGES_CONFIG, additionalQuery?: string) => {
      if (await spaPush(pageName, additionalQuery)) {
        dispatch(setAppPageName(pageName));
      }
    },
    [spaPush, dispatch],
  );

  return useMemo(
    () => ({
      push,
      prefetch,
    }),
    [prefetch, push],
  );
};
